const DISABLED_FIELDS = ['username', 'email', 'phoneNumber'];

export const shouldDisableField = (
  fieldName: string,
  formValues: { [key: string]: any } | boolean | undefined,
  currentDisabled?: boolean
): boolean => {
  
  if (typeof formValues === 'boolean') {
    return formValues;
  }
  
  if (!formValues || typeof formValues !== 'object') {
    if (fieldName === 'email') {
      return false;
    }
    
    return !!currentDisabled || DISABLED_FIELDS.includes(fieldName);
  }
  
  const {email, phoneNumber} = formValues;
  
  if (fieldName === 'email') {
    return email !== undefined && email !== '';
  } else if (fieldName === 'phoneNumber') {
    return phoneNumber !== undefined && phoneNumber !== '';
  }
  
  if (DISABLED_FIELDS.includes(fieldName)) {
    return true;
  }
  
  return !!currentDisabled;
};
